import { computed, provide } from 'vue'

import type { ElementalFormProps } from './types'
import { ElementalFormContextKey } from '~~/src/components/ElementalForm/ElementalFormContextProvider/context'
import type { Elemental } from '~~/src/types/elemental'

export function useElementalFormContext(
  props: ElementalFormProps,
  context: {
    elemental: Ref<Elemental | null | undefined>
    elementalType: ComputedRef<ReturnType<typeof getElementalMetadata>>
    formId: Ref<string>
    onSubmit: () => void
  },
) {
  const { elemental, elementalType, formId, onSubmit } = context

  provide(ElementalFormContextKey, {
    formId,
    elemental,
    elementalType,
    disabled: toRef(Boolean(props.disabled)),
    isSidebarView: toRef(Boolean(props.isSidebarView)),
    isLoading: computed(() => Boolean(props.isLoading)),
    isSaving: computed(() => Boolean(props.isSaving)),
    autosave: computed(() => Boolean(props.autosave)),
    submitError: computed(() => Boolean(props.submitError)),
    dispatchChange: useDebounceFn(() => {
      if (props.autosave && !props.isLoading)
        onSubmit()
    }, 300),
  })
}
